export default {
  web: {
    common: {
      for: "pour",
      today: "Aujourd'hui",
      unknown: "Inconnu",
      checkout: "Passer commande",
      noOdds: "Aucune cote",
    },
    navigation: {
      tools: "Outils",
      getLinematePlus: "Obtenir Linemate+",
      startFreeTrial: "Commencer l'essai gratuit",
      downloadLinemate: "Télécharger Linemate",
      profileSettings: "Paramètres du profil",
      closeMyPicks: "Fermer Mes picks",
      offSeason: "{{league}} est hors saison. À la saison prochaine.",
      search: {
        teams: "Équipes",
        noResultsFor: "Aucun résultat trouvé pour « {{searchTerm}} »",
      },
      toolsMenu: {
        opponentDefensiveRank: "Classement défensif adverse",
        startingOpponentPitchers: "Lanceurs partants adverses",
      },
    },
    toastModal: {
      title: "Quoi de neuf?",
      items: {
        checkout: "Passez à votre book préféré avec Mes picks.",
        preferredOdds: "Affichez les cotes des tendances avec vos cotes préférées (disponible pour les utilisateurs Linemate+).",
      },
      actions: {
        dismiss: "Fermer",
      },
    },
    carousel: {
      previous: "Précédent",
      next: "Suivant",
    },
  },
};
